import { gql } from 'apollo-boost';

export const deleteAllocationMutation = gql`
  mutation deleteAllocationMutation($id: Int!) {
    deleteAllocation(id: $id) {
      success
    }
  }
`;
